import React, { useState } from "react";

function LosatlosShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Comprehensive Junk Removal Services in Los Altos</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p className="resid-rmv">
          <span>Residential Junk Removal:</span>&nbsp;Clear out old furniture,
          mattresses, appliances, and other household items with our efficient
          same-day service.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc">
            <p>
              <span>Commercial Junk Removal:</span>&nbsp;We handle office
              cleanouts, retail space junk removal, and warehouse cleanups for
              businesses of all sizes. <br />
              <span>Construction Debris Removal:</span>&nbsp;From scrap metal to
              yard waste, we provide fast cleanup for construction sites.
              <br />
              <span>Heavy Lifting:</span>&nbsp;Let us handle the heavy lifting
              for items like exercise equipment, hot tubs, and oversized
              furniture.
              <br />
              <span>Hot Tub Removal:</span>&nbsp;Safely and efficiently remove
              old hot tubs with our specialized service.
              <br />
              <span>Mattress Removal:</span>&nbsp;We dispose of old mattresses
              responsibly, using eco-friendly methods.
              <br />
              <span>Yard Waste Removal:</span>&nbsp;Clear out yard debris like
              branches, leaves, and grass with our expert team.
              <br />
              <span>Furniture Removal:</span>&nbsp;We’ll haul away old
              furniture, including couches, chairs, tables, and cabinets.
              <br />
              <span>E-Waste Disposal:</span>&nbsp;Safely recycle electronic
              waste like computers, printers, and other tech equipment.
              <br />
              <span>Trash Removal:</span>&nbsp;Get rid of unwanted junk and
              trash to free up space in your home or office.
              <br />
              <span>Junk Hauling Services:</span>&nbsp;We handle junk hauling
              for all types of items, big or small.
              <br />
              <span>Free Estimates:</span>&nbsp;Receive a free quote with no
              hidden fees and upfront pricing.
              <br />
              <span>Same-Day Service:</span>&nbsp;Need junk gone ASAP? We offer
              same-day junk removal for urgent cleanouts.
              <br />
              <span>Eco-Friendly Solutions:</span>&nbsp;We recycle and donate
              whenever possible, ensuring minimal environmental impact.
            </p>
          </div>

          <h3>Serving Los Altos, CA, and Nearby Areas</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <p className="santa-junk-sec">
            We serve area includes Los Altos, California, and surrounding
            communities like Mountain View, Menlo Park, San Mateo, San Carlos.
            Whether you’re tackling a home cleanout, managing a commercial
            property, or cleaning up a construction site, we’re here to provide
            reliable and affordable service.
          </p>
          <h3>Contact Junk Droid for Junk Removal in Los Altos, CA</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <p>
              Ready to clear out your unwanted junk? Call Junk Droid today for a
              free estimate! Whether it’s old appliances, furniture disposal,
              bulky items, or construction debris removal, we’re your trusted
              partner for junk removal in Los Altos, CA. Book your same-day
              service now and reclaim your space! <br />
              <span>Call Now for a Free Estimate:</span>&nbsp;{" "}
              <a href="tel:+4085397261">(408) 539-7261</a>
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default LosatlosShowHide;
